/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-location',['require','jquery','underscore','marionette','core/templates','core/engine','screens/scenario-mapper/scenario-asset'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Marionette = require('marionette');
  var templates = require('core/templates');
  //var Scenario = require('screens/scenario-mapper/scenario');
  var Engine = require('core/engine');
  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  var ScenarioAsset = require('screens/scenario-mapper/scenario-asset');
  //var ScenarioDialog = require('screens/scenario-mapper/scenario-dialog');

  /*****************************************************************************************************************///}

  var ScenarioLocation = ScenarioAsset.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    name: null,
    imagePath: null,
    description: null,
    performance: 'none',
    activitySwf: null,
    activityXml: null,
    activityType: null,
    activityView: null,

    swfContent: null,
    xmlContent: null,

    swfLoaded: false,
    swfError: false,
    xmlLoaded: false,
    loadError: false,
    xmlError: false,

    originalLoadVals: null,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      ScenarioLocation.instancesArr.push(this);
      ScenarioAsset.prototype.initialize.apply(this, arguments);
    },

    load: function($retry)
    {
      //console.log('Location Load');
      $retry = ($retry === undefined) ? false : $retry;

      if (!$retry && this.checkReady() === true)
      {
        //console.log('location already ready, skip load');
        return;
      }

      this.loadError = false;
      this.swfError = false;
      this.xmlError = false;
      this.swfLoaded = false;
      this.xmlLoaded = false;
      this.swfContent = null;
      this.xmlContent = null;

      //console.log('LOAD LOCATION: (type, xml, swf)', this.activityType, this.activityXml, this.activitySwf);
      if (!this.swfContent)
      {
        this.loadSWF();
      }
      if (!this.xmlContent)
      {
        this.loadXML();
      }
    },

    loadSWF: function(_tries)
    {
      _tries = _tries === undefined ? 0 : _tries;
      _tries++;
      require(['activities/' + this.activityType.replace(/_/g, '-').toLowerCase()], $.proxy(this.onSwfLoadedHandler, this), $.proxy(this.onSwfErrorHandler, this, _tries));
    },

    loadXML: function(_tries)
    {
      _tries = _tries === undefined ? 0 : _tries;
      _tries++;
      require(['text!activities/' + this.activityXml + '.xml'], $.proxy(this.onXmlLoadedHandler, this), $.proxy(this.onXmlErrorHandler, this, _tries));
    },

    resetLocation: function()
    {
      //console.log('reset location');
      this.loadError = false;
      this.swfError = false;
      this.xmlError = false;
      this.swfLoaded = false;
      this.xmlLoaded = false;
      this.swfContent = null;
      this.xmlContent = null;
    },

    create: function()
    {
      //console.log('create new view');
      var View = this.activityView || Marionette.ItemView;

      var $dashName = this.activitySwf.replace(/_/g, '-');
      var $dashXml = this.activityXml.replace(/_/g, '-');
      var $dashType = this.activityType.replace(/_/g, '-').toLowerCase();
      var $addClass = $dashName + ' ' + $dashType + ' ' + $dashXml;
      var $template = templates['activities/' + $dashName] || templates['activities/' + $dashType];
      //var $templateName = ($.inArray($dashType, ['activity-animation', 'activity-placeholder']) !== -1) ? 'activities/' + $dashName : 'activities/' + $dashType;
      ////console.log('create template:' + $templateName);
      return new View({ location: this, xmlData: this.xmlContent, template: $template, addClass: $addClass });
    },

    /*override toString: function()
    {
      var $output = 'Activity (Location): ' + this.name;
      $output = $output.concat('\n', '-- activitySwf: ', (this.this.originalLoadVals ? this.this.originalLoadVals.activitySwf : this.this.activitySwf),
                   '\n', '-- activityXml: ', (this.this.originalLoadVals ? this.this.originalLoadVals.activityXml : this.this.activityXml),
                   '\n', '-- activityType: ', (this.this.originalLoadVals ? this.this.originalLoadVals.activityType : this.this.activityType),
                   '\n', '-- performance: ', this.performance,
                   '\n', '-- ID: ', this._id);
      return $output;
      //return super.toString();
    },*/

    /*****************************************************************************************************************///}

    ///////////////////////
    // INTERNAL METHODS //{
    ///////////////////////

    onSwfLoadedHandler: function(data)
    {
      if (data)
      {
        ////console.log('SWF COMPLETE');
        this.activityView = data;
      }
      this.swfLoaded = true;
      this.checkReady();
    },

    onXmlLoadedHandler: function(data)
    {
      if (data)
      {
        ////console.log('XML COMPLETE');
        this.xmlContent = data;
      }
      this.xmlLoaded = true;
      this.checkReady();
    },

    onSwfErrorHandler: function(_tries, $err, $item)
    {
      if (_tries < 3)
      {
        console.error('Activity Class Load Error:', $err);
        this.loadSWF(_tries);
        return;
      }
      this.loadError = true;
      this.swfError = true;
      this.swfLoaded = true;
      console.error('SWF ERROR: ' + $item, $err);
      this.radio.trigger('check.connection');
      this.checkReady();
    },

    onXmlErrorHandler: function(_tries, $err, $item)
    {
      if (_tries < 3)
      {
        console.error('Activity XML Load Error:', $err);
        this.loadXML(_tries);
        return;
      }
      this.loadError = true;
      this.xmlError = true;
      this.xmlLoaded = true;
      console.error('XML ERROR: ' + $item, $err);
      this.radio.trigger('check.connection');
      this.checkReady();
    },

    checkReady: function()
    {
      //console.log('CHECK READY', this.swfContent, this.xmlContent);
      if (this.swfLoaded && this.xmlContent && !this.swfContent && !this.swfError)
      {
        this.swfContent = this.create();
      }

      if (this.swfContent && this.xmlContent)
      {
        this.trigger(Scenario.LOCATION_READY, this);
        return true;
      }
      //else if (this.swfLoaded && this.xmlLoaded && this.loadError && this.activityXML !== 'placeholder')
      else if (((this.xmlError && this.swfLoaded) || (this.swfError && this.xmlLoaded)) && this.activityXml !== 'placeholder' && Engine.Cheats.settings.chatDebug)
      {
        //console.log(this.swfContent);
        //console.log(this.xmlContent);
        console.error('Load error, loading placeholders.');
       /* this.performance = 'good';
        this.trigger(Scenario.LOCATION_FATAL);
        return false;*/
        if (!this.originalLoadVals)
        {
          this.originalLoadVals = { };
          this.originalLoadVals.activityType = (this.activityType && this.activityType !== '') ? this.activityType : null;
          this.originalLoadVals.activitySwf = (this.activitySwf && this.activitySwf !== '') ? this.activitySwf : null;
          this.originalLoadVals.activityXml = (this.activityXml && this.activityXml !== '') ? this.activityXml : null;
        }

        if (this.swfContent)
          this.swfContent.destroy();

        this.swfContent = null;
        this.xmlContent = null;
        this.activityType = 'Activity_Placeholder';
        this.activitySwf = 'placeholder';
        this.activityXml = 'placeholder';

        this.load(true);
      }
      else if (this.xmlError && this.swfError)
      {
        console.error('Fatal error, bypassing activity.');
        this.performance = 'good';
        this.trigger(Scenario.LOCATION_FATAL);
      }
      return false;
    },

    onBeforeDestroy: function()
    {

    },

    parseData: function(data)
    {
      ScenarioAsset.prototype.parseData.apply(this, arguments);

      this.saType = ScenarioAsset.SA_TYPE_LOCATION;

      this.name = data.Fields.Name;
      this.description = data.Fields.Description;
      this.activitySwf = data.Fields.activitySwf;
      this.activityXml = data.Fields.activityXml;
      this.activityType = data.Fields.activityType;

      this.performance = (data.Fields.performance === '') ? 'none' : data.Fields.performance;
    }

  /*****************************************************************************************************************///}

  });

  ScenarioLocation.instancesArr = [];
  ScenarioLocation.placeholderSwf = '_placeholder';
  ScenarioLocation.placeholderXml = '_placeholder';

  ScenarioLocation.resetPerformance = function()
  {
    _.each(ScenarioLocation.instancesArr, function($location) {
      $location.performance = 'none';
    });
  };

  ScenarioLocation.destroy = function()
  {
    _.each(ScenarioLocation.instancesArr, function(instance) {
      instance.destroy();
    });

    ScenarioLocation.instancesArr = [];
  };

  // EOC
  return ScenarioLocation;

});//EOF
;
